import { FALLBACK_LANGUAGE, LANGUAGES } from '../i18n/languages';

import type { Language } from '../i18n/languages';

/**
 * 로케일 문자열의 언어 — 앱이 고를 수 있는 언어일 때만. `ko-KR`(BCP 47)·`en_US`(Android
 * locale)·`zh-Hans-CN` 모두 앞 subtag 가 언어다. 웹의 기기 로케일 감지도 이것을 쓴다 —
 * 두 쪽 규칙이 갈리면 셸과 화면이 다른 말을 한다.
 */
export const toLanguage = (
  value: string | null | undefined,
): Language | null => {
  const subtag = value?.split(/[-_]/)[0]?.toLowerCase();
  return LANGUAGES.find((lng) => lng === subtag) ?? null;
};

/**
 * 스토어 국가가 정하는 기본 언어 — 한국은 한국어, 중국은 중국어, 그 밖은 영어. iOS 는 App
 * Store 국가를 ISO 3166 alpha-3(`KOR`)로, Android 는 SIM·망 국가를 alpha-2(`kr`)로 주므로
 * 둘 다 받는다. 국가를 모르면 null — 호출부가 기기 로케일로 물러선다.
 */
const COUNTRY_LANGUAGE: Record<string, Language> = {
  KR: 'ko',
  KOR: 'ko',
  CN: 'zh',
  CHN: 'zh',
};

export const countryLanguage = (
  country: string | null | undefined,
): Language | null => {
  const code = country?.trim().toUpperCase();
  if (!code) return null;
  return COUNTRY_LANGUAGE[code] ?? 'en';
};

/**
 * 네이티브 셸이 쓸 언어 — 웹 i18n 의 감지 순서와 같다: 사용자가 웹에서 고른 값
 * (`localStorage` 의 `muzly_language`, 네이티브에는 `languageChanged` 로 온다) → 스토어
 * 국가 → 기기 로케일 → `fallbackLng`. 순서가 같아야 웹이 첫 `languageChanged` 를 보내기
 * 전에도 두 쪽이 다른 말을 하지 않는다.
 */
export const resolveAppLanguage = ({
  chosen,
  storeCountry,
  deviceLocale,
}: {
  chosen?: string | null;
  storeCountry?: string | null;
  deviceLocale?: string | null;
}): Language =>
  toLanguage(chosen) ??
  countryLanguage(storeCountry) ??
  toLanguage(deviceLocale) ??
  FALLBACK_LANGUAGE;
